<!-- Start::app-sidebar -->
<aside class="app-sidebar" id="sidebar" [ngClass]="{ 'sticky-pin': scrolled }">
  <!-- Start::main-sidebar-header -->
  <div class="main-sidebar-header">
    <a [routerLink]="['/']" class="header-logo">
      <img src="./assets/images/Logo-welloo-01.png" alt="logo" class="desktop-logo !h-[4rem]">
      <img src="./assets/images/ico-logo-welloo-01.png" alt="logo" class="toggle-logo">
      <img src="./assets/images/Logo-welloo-01.png" alt="logo" class="desktop-dark !h-[4rem]">
      <img src="./assets/images/ico-logo-welloo-01.png" alt="logo" class="toggle-dark ">
      <img src="./assets/images/Logo-welloo-01.png" alt="logo" class="desktop-white !h-[4rem]">
      <img src="./assets/images/ico-logo-welloo-01.png" alt="logo" class="toggle-white">
    </a>
  </div>
  <!-- End::main-sidebar-header -->

  <!-- Start::main-sidebar -->
  <overlay-scrollbars class="main-sidebar" id="sidebar-scroll">
    <!-- Start::nav -->
    <nav class="main-menu-container nav nav-pills flex-column sub-open">
      <div class="slide-left" id="slide-left" (click)="leftArrowFn()">
        <svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24" height="24" viewBox="0 0 24 24">
          <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path>
        </svg>
      </div>
      <ul class="main-menu" [ngStyle]="{ display: 'block', color: '#ffffff !important' }">
        @for (menuItem of menuItems; track menuItem) {
        <li class="slide" #activeMenuItems [ngClass]="{
            slide__category: menuItem.headTitle, 'slide': menuItem.title,
           'has-sub': menuItem.type === 'sub' && menuItem.title,
            'active': menuItem.selected, open: menuItem.active,
          }" [ngStyle]="{ color: '#fecd1e !important', opacity: '1 !important' }">
          <!-- head title  -->
          @if(menuItem.headTitle){
          <span class="category-name font-bold" [ngStyle]="{ color: '#fecd1e !important' }">
            {{ menuItem.headTitle }}</span>
          }
          <!-- has-Link -->
          @if (menuItem.type === 'link') {
          <a class="side-menu__item" [routerLink]="!menuItem.type ? null : [menuItem.path]" routerLinkActive="active"
            (click)="setNavActive($event, menuItem.path ?? '')">
            @if (menuItem.icon) {
            <span class="iconclick" [appSvgReplace]="menuItem.icon"></span>
            }
            <span class="side-menu__label font-semibold" [ngStyle]="{ color: '#ffffff !important' }">{{ menuItem.title
              }}
              <span class="badge bg-{{ menuItem.badgeClass }}">{{
                menuItem.badgeValue
                }}</span>
            </span>
          </a>
          }
          <!-- has-empty -->
          @if (menuItem.type === 'empty') {
          <a class="side-menu__item" href="javascript:;" (click)="setNavActive($event, menuItem.path ?? '')">
            @if (menuItem.icon) {
            <span class="iconclick" [appSvgReplace]="menuItem.icon"></span>
            }
            <span class="side-menu__label font-semibold" [ngStyle]="{ color: '#ffffff !important' }">{{ menuItem.title
              }}
              <span class="badge bg-warning ms-2">hot</span>
            </span>
          </a>
          }
          <!-- has-Sub -->
          @if (menuItem.type === 'sub') {
          <a class="side-menu__item" [routerLink]="menuItem.type ? null : [menuItem.path]"
            [ngClass]="{ active: menuItem.selected }" (click)="toggleNavActive($event, menuItem)">
            @if (menuItem.icon) {
            <span class="iconclick" [appSvgReplace]="menuItem.icon"></span>
            }
            <span class="side-menu__label font-semibold" [ngStyle]="{ color: '#ffffff !important' }">{{ menuItem.title
              }}
              <span class="badge bg-{{ menuItem.badgeClass }} ms-2">{{
                menuItem.badgeValue
                }}</span>
            </span>
            <i class="ri-arrow-down-s-line side-menu__angle"></i>
          </a>
          }
          <!-- 2nd Level menu -->
          @if (menuItem.children) {
          <ul class="slide-menu child1" [ngClass]="{
              active: menuItem.active,
              'double-menu-active': menuItem.active,
              'force-left': menuItem.dirchange
            }" [ngStyle]="{ display: menuItem.active ? 'block' : 'none' }">
            <li class="slide side-menu__label1 font-semibold">
              <a href="javascript:void(0)" [ngStyle]="{ color: '#ffffff !important' }">{{ menuItem.title }}</a>
            </li>
            @for (childrenItem of menuItem.children; track childrenItem) {
            <li class="slide" [ngClass]="{ active: childrenItem.selected }" appDropdownPosition [ngClass]="{
                open: childrenItem.active,
                'has-sub': childrenItem.type === 'sub',
                active: childrenItem.selected
              }">
              <!-- link -->
              @if (childrenItem.type === 'link') {
              <a class="side-menu__item font-medium" [routerLink]="!childrenItem.type ? null : [childrenItem.path]"
                routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                (click)="setNavActive($event, childrenItem.path ?? '')">
                <span [ngStyle]="{ color: '#ffffff !important' }">{{ childrenItem.title }}</span>
              </a>
              }
              <!-- empty -->
              @if (childrenItem.type === 'empty' ) {
              <a class="side-menu__item font-medium" href="javascript:;"
                (click)="setNavActive($event, childrenItem.path ?? '')">
                <span [ngStyle]="{ color: '#ffffff !important' }">{{ childrenItem.title }}</span>
              </a>
              }
              <!-- sub -->
              @if (childrenItem.type === 'sub') {
              <a class="side-menu__item font-medium" [ngClass]="{ active: childrenItem.selected }"
                [routerLink]="childrenItem.type ? null : [childrenItem.path]"
                (click)="toggleNavActive($event, childrenItem)">
                <span class="" [ngStyle]="{ color: '#ffffff !important' }">{{ childrenItem.title }}</span>
                <i class="ri-arrow-down-s-line side-menu__angle"></i>
              </a>
              }
              <!-- 3rd Level menu -->
              @if (childrenItem.children) {
              <ul class="slide-menu child2"
                [ngClass]="{ 'force-left': childrenItem.dirchange, active: menuItem.active }"
                [ngStyle]="{display: childrenItem.active ? 'block' : 'none'}">
                @for (childrenSubItem of childrenItem.children; track
                childrenSubItem) {
                <li class="slide" appDropdownPosition [ngClass]="{ open: childrenSubItem.active,
                    'has-sub': childrenSubItem.type === 'sub',
                    active: childrenSubItem.selected
                  }">
                  @if (childrenSubItem.type === 'link') {
                  <a class="side-menu__item font-medium" routerLinkActive="active"
                    [routerLink]="!childrenSubItem.type ? null : [childrenSubItem.path]"
                    [routerLinkActiveOptions]="{ exact: true }"
                    (click)="setNavActive($event, childrenSubItem.path ?? '')">
                    <span [ngStyle]="{ color: '#ffffff !important' }">{{ childrenSubItem.title }}</span>
                  </a>
                  } @if (childrenSubItem.type === 'empty') {
                  <a class="side-menu__item font-medium" href="javascript:;">
                    <span [ngStyle]="{ color: '#ffffff !important' }">{{ childrenSubItem.title }}</span> </a>
                  } @if (childrenSubItem.type === 'sub') {
                  <a class="side-menu__item font-medium" [ngClass]="{ active: childrenSubItem.selected }"
                    [routerLink]="childrenSubItem.type ? null : [childrenSubItem.path]"
                    (click)="toggleNavActive($event, childrenSubItem)"> <span class=""
                      [ngStyle]="{ color: '#ffffff !important' }">{{ childrenSubItem.title
                      }}</span>
                    <i class="ri-arrow-down-s-line side-menu__angle"></i>
                  </a>
                  }
                  <!-- 3rd Level menu -->
                  @if (childrenSubItem.children) {
                  <ul class="slide-menu child3" [ngClass]="{ 'force-left': childrenItem.dirchange }"
                    [ngStyle]="{ display: childrenSubItem.active ? 'block' : 'none'}">
                    @for (childrenSubItem1 of childrenSubItem.children; track
                    childrenSubItem1) {
                    <li class="slide" [ngClass]="{ open: childrenSubItem1.active }">
                      @if (childrenSubItem1.type === 'link') {
                      <a class="side-menu__item font-medium" routerLinkActive="active" [routerLink]="
                          !childrenSubItem1.type
                            ? null
                            : [childrenSubItem1.path]
                        " [routerLinkActiveOptions]="{ exact: true }">
                        <span [ngStyle]="{ color: '#ffffff !important' }">{{ childrenSubItem1.title }}</span>
                      </a>
                      } @if (childrenSubItem1.type === 'empty') {
                      <a class="side-menu__item font-medium" href="javascript:;">
                        <span [ngStyle]="{ color: '#ffffff !important' }">{{ childrenSubItem1.title }}</span>
                      </a>
                      }
                    </li>
                    }
                  </ul>
                  }
                </li>
                }
              </ul>
              }
            </li>
            }
          </ul>
          }
        </li>
        @if (menuItem.type === 'external') {
        <a class="side-menu__item" target="_blank" [routerLink]="!menuItem.type ? null : [menuItem.path]"
          routerLinkActive="active" (click)="setNavActive($event, menuItem.path ?? '')">
          @if (menuItem.icon) {
          <i class="side-menu__icon  bx bx-{{ menuItem.icon }}"></i>
          }
          <span class="side-menu__label font-semibold" [ngStyle]="{ color: '#ffffff !important' }">{{ menuItem.title }}
            <span class="badge bg-{{ menuItem.badgeClass }} float-end">{{
              menuItem.badgeValue
              }}</span>
          </span>
        </a>
        }
        }
        <!-- End::slide -->
      </ul>
      <div class="slide-right" id="slide-right" (click)="rightArrowFn()">
        <svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24" height="24" viewBox="0 0 24 24">
          <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path>
        </svg>
      </div>
    </nav>
    <!-- End::nav -->
  </overlay-scrollbars>
  <!-- End::main-sidebar -->
</aside>
<!-- End::app-sidebar -->